<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    
    <div class="w-full">
        <p class="pb-2">
          <vs-button v-if="$store.state.dash.viewData.currentShowcasedIDs.length !== 0" class="w-full hidden md:flex md:w-64 mt-3 md:mt-0 md:float-right lg:mr-1" icon-pack="feather" icon-after icon="icon-plus" @click="() => {
              $router.push('/dash/showcase/setupwidget/choose')
            }">Create Widget</vs-button>          
          <Pagesubtitle
      subTitle="Install widgets on your website that elegantly showcase your best reviews & feedback."
    />
        </p>
      </div>     

  <div class="text-center py-10" v-if="!$store.state.dash.viewState.widgetsLoaded || !$store.state.dash.viewState.showcaseDataLoaded">
          <p class="mb-2">Loading showcase...</p>
          <div class="w-8 h-8 pt_loading inline-block"></div>
  </div>
  <div v-else>

    <vs-tabs class="mt-base" v-model="currentTab" >
      
      <vs-tab label="Widgets" class="px-1 pt-base">
        <div v-if="$store.state.dash.viewData.currentWidgets.length > 0">
          <p class="text-center mb-5" v-if="widgetsLoading">Widgets are being prepared... This should take less than 30 seconds...</p>
      <div
        class="items-list-view mb-5"
        v-for="widget in $store.state.dash.viewData.currentWidgets"
        :key="widget.widgetID"
      >
        <div class="vx-card list-view-item overflow-hidden py-4 sm:py-0">
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-row item-details no-gutter relative">
              <div
                class="
                  py-6
                  px-10
                  vx-col
                  w-full
                  item-img-container
                  bg-white
                  md:flex
                  items-center
                  justify-between
                "
              >
                <span class="w-full my-4 block md:w-100 font-semibold text-lg">{{widget.name}}</span>
                <span class="w-full my-4 text-sm block md:mx-4 md:w-32">{{widget.type === 'generalnudge' ? 'Nudge' : 'Wall of proof'}}</span>
                <div class="w-full my-4 block md:ml-10">
                  <span v-if="widget.showAllTags" >All tags</span>
                  <div v-else>
                    <span class="mr-2 inline-block" v-for="(tag,i) in widget.showOnlyTags" :key="tag">{{ tag }}{{ i === widget.showOnlyTags.length - 1 ? '' : ','}}</span>                    
                  </div>
                </div>
                <div class="flex flex-wrap w-full">
                  <vs-button class="mx-1 mt-2 lg:mt-0" type="border" icon-pack="feather" icon="icon-trash" @click="() => {
                      
                    currentWidgetToRemoveID = widget.widgetID
                    currentWidgetToRemoveName = widget.name
                    showSureRemoveWidget = true

                    }"></vs-button>
                  <vs-button class="mx-1 mt-2 lg:mt-0" type="border" @click="$router.push(`/dash/showcase/${widget.widgetID}`)">Install</vs-button>
                  <vs-button class="mx-1 mt-2 lg:mt-0" type="border" :disabled="widgetsLoading" @click="$router.push(`/dash/showcase/setupwidget/${widget.widgetID}`)">Edit</vs-button>
                  <vs-button class="mx-1 mt-2 lg:mt-0" @click="previewWidget(widget.widgetID, widget.type, widget.name)" :disabled="widgetsLoading">{{ widgetsLoading ? 'Loading...' : 'Preview' }}</vs-button>
                </div>                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$store.state.dash.viewData.currentShowcasedIDs.length !== 0 && $store.state.dash.viewData.currentWidgets.length === 0" class="py-10 text-center">
      <p class="font-semibold text-xl mt-base mb-4">You don't have any widgets. </p>
      <p class="mb-base">Choose one below to create a showcase widget for your website.</p>
    </div>
    <div
      v-if="$store.state.dash.viewData.currentShowcasedIDs.length === 0"
      class="text-center py-20"
    >
      <h5>No items currently on showcase.</h5>
      <h1 class="my-10 mx-auto max-w-lg font-semibold">
        Before you can create a widget, you need to mark reviews or feedback for
        showcase.
      </h1>
      <h5>Choose "Add to Showcase" to get started.</h5>
      <vs-button
        @click="
          () => {
            $router.push('/dash/responses');
            $vs.notify({
              title: 'Select new responses for showcase',
              text: 'Click on \'Showcase\' next to a piece of feedback or review to select it for showcase.',
              color: 'primary',
              time: 15000,
              iconPack: 'feather',
              icon: 'icon-info',
            });
          }
        "
        class="inline-block mt-10"
        size="large"
        >Add to Showcase</vs-button
      >
    </div>
    <div class="my-10" v-else>
      <h5 class="my-4 mt-base">Create Widget</h5>
      <div class="vx-row">
        <div class="vx-col md:w-5/12">
          <p class="font-semibold text-xl mb-5">Wall of Proof</p>
          <img class="w-full rounded block" src="@/assets/images/misc/WOP.png" />
          <vs-button
            class="my-5 w-full"
            type="border"
            @click="optCreateWidget('wallofproof')"
            >Create widget</vs-button
          >
          <p class="mb-5">
            Embed a beautiful selection of reviews & feedback right into your
            page.
          </p>
        </div>
        <div class="vx-col md:w-5/12">
          <p class="font-semibold text-xl mb-5">Showcase Nudge</p>
          <img class="w-full rounded block" src="@/assets/images/misc/GN.png" />
          <vs-button
            class="my-5 w-full"
            type="border"
            @click="optCreateWidget('generalnudge')"
            >Create widget</vs-button
          >
          <p class="mb-5">
            Eloquently surface your best reviews & feedback in the bottom right
            or left corner of your site.
          </p>
        </div>
      </div>
    </div>  
      </vs-tab>
      
      <vs-tab label="Domain Settings" class="px-1 pt-base">
        
        <div class="vx-row">
          <div class="vx-col w-full md:w-1/2">           
            <DomainSettings :domainSettingsUpdated="domainSettingsUpdated"/>
            <vs-alert      
      class="p-2 w-full mb-base rounded flex items-center text-dark"
      color="primary"
    >
      <div>
        <span>Your domain settings for showcase are shared accross all locations. Different requirements? <a href="" @click.prevent="chatToUs">Talk to us</a></span>
      </div>
      
    </vs-alert> 
            <vs-button class="mt-4" size="large" @click="updateDomainSettings">Update Settings</vs-button>
            
          </div>
        </div>

      </vs-tab>
    </vs-tabs>

  </div>



    <SideSlide    
      v-if="showPreviewWidget" 
      @close="showPreviewWidget = false"
      size="large"
      >    
      <div>        
        <iframe class="w-full h-200 wpreview" style="height: 74vh;" :src="iframeSrc" ref="widgetpreviewframe"></iframe>
      </div>    
      <div class="flex justify-center">        
        <vs-button class="mx-1 w-64" type="border" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshFrame">Refresh</vs-button>                
      </div>
      <p class="text-center mt-2 w-full">Widget not updated? Please give a minute before refreshing...</p>      
    </SideSlide>

    <SideSlide
      v-if="showSideSlide"
      @close="closeSideSlide"
    >
      <div v-if="timeSCreated - currentInstallWidgetData.timeCreatedS < 20" >
        <h3 class="text-center mt-2 mb-8">Widget Created!</h3>               
      </div>
      <div v-else class="text-center mt-2 mb-8">
        <h3>Widget Installation</h3>
        </div>
              
      <div v-if="currentInstallWidgetData.type === 'wallofproof'">        
              
        <p class="my-4 font-medium"><span class="font-semibold">Step 1. </span>Copy and paste the below code snippet  <span class="font-semibold">right before the &lt;/body&gt; tag</span> in all HTML pages where you want to display your widget.</p>
        <div class="vx-card p-0">
          <div class="text-dark px-3 py-5 rounded italic w-full">
          <pre :id="`${currentInstallWidgetData.widgetID}code`" class="w-full bg-white block overflow-x-scroll p-0" >&lt;script&gt;
  //Feedback Link Showcase Widget "{{ currentInstallWidgetData.name }}":
  ! function(w, d){
    if (!w || !d) return false    
    d.addEventListener("DOMContentLoaded", function(event) {
        var s = d.createElement('script');
        s.setAttribute('src','https://fbl.embedwidgets.com/{{
              currentInstallWidgetData.widgetID
            }}.js');
        d.body.appendChild(s);
      });
    }(window, document)
 &lt;/script&gt;</pre>      
        </div>        
        </div>
        <vs-button @click="copyCode(currentInstallWidgetData.widgetID, 'code')" type="border" class="w-full" icon-pack="feather" :icon="lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? '' : 'icon-copy'" icon-after>{{ lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? 'Copied!' : 'Copy' }}</vs-button>        
        <p class="mt-4 text-light">Remember to place this script <span class="font-bold">right above</span> the &lt;/body&gt; tag.</p>        
        <p class="my-4 font-medium"><span class="font-semibold">Step 2. </span>Copy and paste the below code snippet at the <span class="font-semibold">exact position</span> where you want your Wall of Proof to be displayed.</p>        
        <div class="vx-card p-0">
          <div class="text-dark px-3 py-5 rounded italic w-full">
          <pre :id="`${currentInstallWidgetData.widgetID}div`" class="w-full bg-white block overflow-x-scroll p-0">&lt;div class="fbl_w_{{currentInstallWidgetData.widgetID}}"&gt;&lt;/div&gt;</pre>          
        </div>        
        </div>
        <vs-button @click="copyCode(currentInstallWidgetData.widgetID, 'div')" type="border" class="w-full" icon-pack="feather" :icon="lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}div` ? '' : 'icon-copy'" icon-after>{{ lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}div` ? 'Copied!' : 'Copy' }}</vs-button>        
        <p class="my-4 font-medium">You can place more than one of these snippets anywhere on the page. The Wall of Proof will be loaded in those position(s).</p>      
      </div>
      <div v-else>

        <p class="my-4 font-medium">Copy and paste the below code snippet anywhere before the &lt;/body&gt; tag in all HTML pages where you want the widget to be displayed.</p>
        <div class="vx-card">
        <div class="text-dark px-5 py-3 rounded w-full">
          <pre :id="`${currentInstallWidgetData.widgetID}code`" class="w-full bg-white block overflow-x-scroll">&lt;script&gt;
  //Feedback Link Showcase Widget "{{ currentInstallWidgetData.name }}":
  ! function(w, d){
    if (!w || !d) return false
    d.addEventListener("DOMContentLoaded", function(event) {
        var s = d.createElement('script');
        s.setAttribute('src','https://fbl.embedwidgets.com/{{
              currentInstallWidgetData.widgetID
            }}.js')
        d.body.appendChild(s);
    });
    }(window, document);
 &lt;/script&gt;</pre>
        </div>
        </div>      
        <vs-button @click="copyCode(currentInstallWidgetData.widgetID, 'code')" type="border" class="w-full" icon-pack="feather" :icon="lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? '' : 'icon-copy'" icon-after>{{ lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? 'Copied!' : 'Copy' }}</vs-button>        
      </div>     
    </SideSlide>

      <vs-popup class="holamundo" title="Remove widget" :active.sync="showSureRemoveWidget" @close="() => {
          showSureRemoveWidget = false
          removeText = ''
        }">
        <div class="con-vs-alert mt-3 con-vs-alert-danger">
          <h4 class="titlex vs-alert--title">Warning</h4>
          <div class="vs-alert text-lg">
            If you remove this widget, you will lose all settings, and it will cease working on your site(s).
          </div>
        </div>
        <vs-divider class="my-4"/>
        <p class="text-lg mb-2">
          If you're sure you want to remove the widget <span class="font-medium text-xl">"{{ currentWidgetToRemoveName }}"</span>, please type "remove" in the below textbox.</p>
        <vs-input placeholder="Type 'remove' to continue." v-model="removeText"/>
        <div class="overflow-auto mt-4">
          <vs-button class="float-right ml-1" @click="() => {
              removeWidget(currentWidgetToRemoveID)
              showSureRemoveWidget = false
              removeText = ''
            }" :disabled="removeText !== 'remove'">Remove</vs-button>
          <vs-button type="border" class="float-right" @click="() => {
            showSureRemoveWidget = false
            removeText = ''
          }">Cancel</vs-button>
        </div>
      </vs-popup>





  </div>
</template>

<script>


/*


   <vs-popup class="fullscreen-popup" title="Preview Widget" 
      :active.sync="showPreviewWidget" 
      @close="showPreviewWidget = false">
      <div>        
        <iframe class="w-full h-200 wpreview" style="height: 74vh;" :src="iframeSrc" ref="widgetpreviewframe"></iframe>
      </div>
      <div class="flex justify-center">
        <vs-button class="mx-1 w-64" type="border" @click="showPreviewWidget = false">Close</vs-button>        
        <vs-button class="mx-1 w-64" type="border" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshFrame">Refresh</vs-button>                
      </div>
      <p class="text-center mt-2 w-full">Widget not updated? Please give a minute before refreshing...</p>
      </vs-popup>   

<vs-popup
      class="holamundo"
      size="large"
      title="Install Widget"
      :active.sync="showSideSlide"
      @close="
        () => {
          showSideSlide = false;
          $router.replace('/dash/showcase')
        }
      "
    >
      <div v-if="timeSCreated - currentInstallWidgetData.timeCreatedS < 20" >
        <h3 class="text-center mt-2 mb-8">Widget Created!</h3>               
      </div>
      <div v-else class="text-center mt-2 mb-8">
        <h3>Widget Installation</h3>
        </div>
              
      <div v-if="currentInstallWidgetData.type === 'wallofproof'">        
              
        <p class="my-4 font-medium"><span class="font-semibold">Step 1. </span>Copy and paste the below code snippet  <span class="font-semibold">right before the &lt;/body&gt; tag</span> in all HTML pages where you want to display your widget.</p>
        <div class="vx-card p-0">
          <div class="text-dark px-3 py-5 rounded italic w-full">
          <pre :id="`${currentInstallWidgetData.widgetID}code`" class="w-full bg-white block overflow-x-scroll p-0" >&lt;script&gt;
  //Feedback Link Showcase Widget "{{ currentInstallWidgetData.name }}":
  ! function(w, d){
    if (!w || !d) return false    
    d.addEventListener("DOMContentLoaded", function(event) {
        var s = d.createElement('script');
        s.setAttribute('src','https://fbl.embedwidgets.com/{{
              currentInstallWidgetData.widgetID
            }}.js');
        d.body.appendChild(s);
      });
    }(window, document)
 &lt;/script&gt;</pre>      
        </div>        
        </div>
        <vs-button @click="copyCode(currentInstallWidgetData.widgetID, 'code')" type="border" class="w-full" icon-pack="feather" :icon="lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? '' : 'icon-copy'" icon-after>{{ lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? 'Copied!' : 'Copy' }}</vs-button>        
        <p class="mt-4 text-light">Remember to place this script <span class="font-bold">right above</span> the &lt;/body&gt; tag.</p>        
        <p class="my-4 font-medium"><span class="font-semibold">Step 2. </span>Copy and paste the below code snippet at the <span class="font-semibold">exact position</span> where you want your Wall of Proof to be displayed.</p>        
        <div class="vx-card p-0">
          <div class="text-dark px-3 py-5 rounded italic w-full">
          <pre :id="`${currentInstallWidgetData.widgetID}div`" class="w-full bg-white block overflow-x-scroll p-0">&lt;div class="fbl_w_{{currentInstallWidgetData.widgetID}}"&gt;&lt;/div&gt;</pre>          
        </div>        
        </div>
        <vs-button @click="copyCode(currentInstallWidgetData.widgetID, 'div')" type="border" class="w-full" icon-pack="feather" :icon="lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}div` ? '' : 'icon-copy'" icon-after>{{ lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}div` ? 'Copied!' : 'Copy' }}</vs-button>        
        <p class="my-4 font-medium">You can place more than one of these snippets anywhere on the page. The Wall of Proof will be loaded in those position(s).</p>      
      </div>
      <div v-else>

        <p class="my-4 font-medium">Copy and paste the below code snippet anywhere before the &lt;/body&gt; tag in all HTML pages where you want the widget to be displayed.</p>
        <div class="vx-card">
        <div class="text-dark px-5 py-3 rounded w-full">
          <pre :id="`${currentInstallWidgetData.widgetID}code`" class="w-full bg-white block overflow-x-scroll">&lt;script&gt;
  //Feedback Link Showcase Widget "{{ currentInstallWidgetData.name }}":
  ! function(w, d){
    if (!w || !d) return false
    d.addEventListener("DOMContentLoaded", function(event) {
        var s = d.createElement('script');
        s.setAttribute('src','https://fbl.embedwidgets.com/{{
              currentInstallWidgetData.widgetID
            }}.js')
        d.body.appendChild(s);
    });
    }(window, document);
 &lt;/script&gt;</pre>
        </div>
        </div>      
        <vs-button @click="copyCode(currentInstallWidgetData.widgetID, 'code')" type="border" class="w-full" icon-pack="feather" :icon="lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? '' : 'icon-copy'" icon-after>{{ lastCopiedToClipboard === `${currentInstallWidgetData.widgetID}code` ? 'Copied!' : 'Copy' }}</vs-button>        
      </div>
      <div class="flex justify-end pt-4">
        <vs-button
          class="ml-1 px-32"
          @click="
            () => {
              showSideSlide = false
              $router.replace('/dash/showcase');
            }
          "
          >Ok</vs-button
        >
      </div>
    </vs-popup>

*/







/*

NB!!!

//if domain settings needs to be updated, 
//remember to only upate the [0] element on entity.showcase

*/


import DomainSettings from './Components/DomainSettings.vue'
import Savebutton from "../components/ptcomponents/Savebutton.vue";
import Pagesubtitle from "../components/ptcomponents/Pagesubtitle.vue";
import SideSlide from "../components/ptcomponents/sideslide/SideSlide.vue";

export default {
  computed: {
    widgetsLoading() {
      return this.$store.state.dash.viewData.buildWidgetsTimeout
    }
  },
  data() {
    return {
      lastCopiedToClipboard: false, //wIDcode or wIDdiv
      domainSettings: {
        domainBase: '',
        subs: []
      },
      currentTab: 0,
      showSideSlide: false,    
      iframeSrc: '',
      lastWidgetId: null,
    lastWidgetType: null,
    lastWidgetName: null,
      showPreviewWidget: false,
      currentInstallWidgetData: false,
      timeSCreated: Math.floor(new Date().getTime() / 1000),
      uniquePopupID: Math.floor(new Date().getTime() / 1000),
      // 
      showSureRemoveWidget: false,
      currentWidgetToRemoveID: false,
      currentWidgetToRemoveName: false,
      removeText: ''
    }
  },
  components: {
    Pagesubtitle,
    Savebutton,
    DomainSettings,
    SideSlide
  },
  created() {
    //do we need to show install instructions?
     this.checkShowWidgetInstall()
  },
  watch: {
    '$route'() {
      this.checkShowWidgetInstall()
    }
  },
  methods: {
    generateScriptTag(wID, widgetName) {
  return `<script>! function(w, d){if (!w || !d) return false; d.addEventListener("DOMContentLoaded", function(event) { var s = d.createElement('script'); s.setAttribute('src','https://fbl.embedwidgets.com/${wID}.js'); d.body.appendChild(s); });}(window, document);${'</'}script>`;
},
refreshFrame() {
    // call previewWidget again with the last used parameters
    if (this.lastWidgetId && this.lastWidgetType && this.lastWidgetName) {
      this.previewWidget(this.lastWidgetId, this.lastWidgetType, this.lastWidgetName);
    }
  },
previewWidget(wID, widgetType, widgetName) {

  this.showPreviewWidget = true;

  this.lastWidgetId = wID;
  this.lastWidgetType = widgetType;
  this.lastWidgetName = widgetName;

  setTimeout(() => {
    const iframe = this.$refs.widgetpreviewframe;
  let doc = iframe.contentWindow || iframe.contentDocument;

  if (doc.document) {
    doc = doc.document;
  }

  let scriptTag = this.generateScriptTag(wID, widgetName);

  let bodyContent = '';
  if (widgetType === 'wallofproof') {

    // Add low-fidelity mockup blocks
  bodyContent += `
    <div style="padding: 0 5%; box-sizing: border-box;">
    <div style="border-radius: 8px; background-color: #F1F1F1; width: 100%; height: 50px; margin-bottom: 2%; box-sizing: border-box; padding-left: 10px; line-height: 50px; color: gray; font-family: sans-serif;">YOUR WEBSITE</div>
    <div class="fbl_w_${wID}"></div>
    </div>`;
  } else {
  // Add low-fidelity mockup blocks
  bodyContent += `
    <div style="padding: 0 5%; box-sizing: border-box;">
    <div style="border-radius: 8px; background-color: #F1F1F1; width: 100%; height: 50px; margin-bottom: 1%; box-sizing: border-box; padding-left: 10px; line-height: 50px; color: gray; font-family: sans-serif;">
      YOUR WEBSITE
    </div>
    <p style="color: gray; font-family: sans-serif; font-size: 14px;">(Your nudge will show in a moment in a bottom corner...)</p>
    <div style="display: flex; justify-content: space-between;">
      <div style="border-radius: 8px; background-color: #F1F1F1; width: 32.3%; height: 1000px; margin-bottom: 5%; "></div>
      <div style="border-radius: 8px; background-color: #F1F1F1; width: 32.3%; height: 1000px; margin-bottom: 5%;"></div>
      <div style="border-radius: 8px; background-color: #F1F1F1; width: 32.3%; height: 1000px; margin-bottom: 5%;"></div>
    </div>
    <style>body{overflow: hidden;}</style>
    </div>`;
  
  }


  let htmlContent = `<!DOCTYPE html><html><head><title>Your Title</title>${widgetType === 'wallofproof' ? scriptTag : ''}</head><body>${widgetType === 'generalnudge' ? scriptTag : ''}${bodyContent}</body></html>`;

  doc.open();
  doc.write(htmlContent);
  doc.close();
  },10)

},

    copyCode(wID, codeOrDiv) {

      try {
        this.copyTextToClipboard(document.getElementById(`${wID}${codeOrDiv}`).textContent)
        this.lastCopiedToClipboard = `${wID}${codeOrDiv}`
      } catch (e) {
        console.log(e)
      }
      
    },
    updateDomainSettings() {


      //VALIDATION

      let error = false
      if (this.errors.any()) error  = this.errors.all()[0]


      this.domainSettings.domainBase = this.domainSettings.domainBase.trim()

          const dotIndex = this.domainSettings.domainBase.indexOf('.')

          if (
            this.domainSettings.domainBase.length === 0 || 
            dotIndex == 0 || 
            dotIndex == -1 || 
            this.domainSettings.domainBase.length === dotIndex + 1
            ) error = 'We need a valid main domain for where your widgets will be hosted.'


          try {
            const dmn = new URL('https://' + this.domainSettings.domainBase)
          } catch (e){
            error = 'Invalid main domain: We need a valid main domain for where your widgets will be hosted.'
          }          


          const theSubs = [...this.domainSettings.subs]

          theSubs.forEach((sub,i) => {
            if (sub.length === 0) this.domainSettings.subs.splice( i, 1)
          })


      if (error) {
        this.$vs.notify({
            title: '',
            text: error,
            color: 'warning',
            time: 12500,
            iconPack: 'feather',
            icon:'icon-alert-circle'
        }) 
        return  
      } 

            this.$vs.notify({
              title: '',
              text: 'Updating domain settings...',
              color: 'primary',
              time: 1500,
              iconPack: 'feather',
              icon:'icon-info'
          }) 

       this.$store.dispatch('dash/UPDATE_DOMAIN_SETTINGS', this.domainSettings).then(() => {

           this.$vs.notify({
              title: '',
              text: 'Domain settings updated',
              color: 'success',
              time: 10000,
              iconPack: 'feather',
              icon:'icon-check'
            })   

      }).catch(() => {

        this.$vs.notify({
            title: '',
            text: 'Oops! There was a problem while trying to update your settings. Please try again or reach out to support.',
            color: 'warning',
            time: 15000,
            iconPack: 'feather',
            icon:'icon-alert-circle'
        }) 

      })

    },
     domainSettingsUpdated(v) {

      this.domainSettings.subs = [...v.subs.map(itm => itm.text)]
      this.domainSettings.domainBase = v.domainBase

    },
    removeWidget(id) {

        this.$vs.notify({
              title: '',
              text: 'Removing widget...',
              color: 'primary',
              time: 1500,
              iconPack: 'feather',
              icon:'icon-info'
          }) 

       this.$store.dispatch('dash/REMOVE_WIDGET', id).then(() => {

          //resync widget data
          this.$store.dispatch('dash/SYNC_WIDGETS').finally(() => {

            this.$vs.notify({
              title: 'Widget Removed',
              text: 'Widget removed successfully.',
              color: 'success',
              time: 15000,
              iconPack: 'feather',
              icon:'icon-check'
            })           

          })

      }).catch(() => {

        this.$vs.notify({
            title: 'Remove widget',
            text: 'Oops! There was a problem while trying to remove your widget. Please try again or reach out to support.',
            color: 'warning',
            time: 15000,
            iconPack: 'feather',
            icon:'icon-alert-circle'
        }) 

      })



    },
    closeSideSlide() {
      this.showSideSlide = false
      this.$router.replace('/dash/showcase')
    },
    checkShowWidgetInstall() {

      //check if we have widget id in param:

      if (typeof this.$route.params.installwidgetinstructions !== "undefined") {

      const widgetID = this.$route.params.installwidgetinstructions;
      let found = false;

      this.$store.state.dash.viewData.currentWidgets.forEach((w) => {
        if (w.widgetID === widgetID) found = { ...w };
      });

      if (found) {
        this.currentInstallWidgetData = found;
        this.showSideSlide = true;
        this.uniquePopupID = Math.floor(new Date().getTime())
      } else {
        this.$router.replace("/dash/showcase");
      }

      }

    },
    optCreateWidget(type) {
      this.$router.push(`/dash/showcase/setupwidget/${type}`);
    },
  },
};
</script>


<style lang="scss">

.fullscreen-popup .vs-popup {
  width: 95vw; /* 95% of viewport width */
  height: 95vh; /* 95% of viewport height */
  max-width: 95vw; /* to ensure the width does not exceed the viewport width */
  max-height: 95vh; /* to ensure the height does not exceed the viewport height */
}


iframe.wpreview {
  outline: none;
  border: none;
}

</style>
